import { connect } from 'react-redux';
import { getExportPndErrors, clearDownloadPndDataErrors, downloadPndData } from 'src/reducers/employees/employeePays';
import ExportPndModal from '../components/ExportPndModal';
import { FORM_NAME_PAYS_SEARCH, takePaymentRangeFormSearchForm } from 'src/reducers/searchForm';

const mapStateToProps = state => ({
  paymentRange: takePaymentRangeFormSearchForm(state, FORM_NAME_PAYS_SEARCH),
  errors: getExportPndErrors(state)
});
const mapDispatchToProps = dispatch => ({
  onModalHide: () => dispatch(clearDownloadPndDataErrors()),
  handleSubmit: (data, paymentRange) => {
    dispatch(downloadPndData({ ...data, ...paymentRange }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportPndModal);